import React, { useState } from "react";
import BaseModal from "./BaseModal";
import { signupRestaurant } from "../../api/restaurantApi";
import { useNavigate } from "react-router-dom";
import PasswordPolicyChecker from "../PasswordPolicyChecker";

const SignUpModal = ({ isOpen, onRequestClose, toggleView, width }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleNameChange = (e) => {
    setFormData((prevState) => ({ ...prevState, name: e.target.value }));
  };

  const handleEmailChange = (e) => {
    setFormData((prevState) => ({ ...prevState, email: e.target.value }));
  };

  const handlePasswordChange = (e) => {
    setFormData((prevState) => ({ ...prevState, password: e.target.value }));
  };

  const handleConfirmPasswordChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      confirmPassword: e.target.value,
    }));
  };

  // handle updated password validity from PasswordPolicy component
  const updatePasswordValidity = (isValid) => {
    setIsPasswordValid(isValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await signupRestaurant(
        formData.name,
        formData.email,
        formData.password,
        window.location.pathname,
      );
      if (response.error) {
        alert(response.error);
        return;
      }
      const restaurant = response.restaurant;
      localStorage.setItem("authToken", response.token);
      localStorage.setItem("restaurant", JSON.stringify(restaurant));
      setTimeout(() => {
        onRequestClose();
      }, 1000);
      navigate(`/admin/restaurant/${restaurant.id}/menu/${restaurant.menu.id}`);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose} width={width}>
      <div className="base-modal">
        <div className="base-modal-header">
          <div className="base-modal-company-logo">
            <img src="/logo.png" alt="tastelens" />
            <h1>sign up</h1>
          </div>
          <h2>enter your details to create your account and get started</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="signup-restaurant-name">restaurant name</label>
          <input
            type="text"
            id="signup-restaurant-name"
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            placeholder="enter restaurant name"
            required
          />
          <br />
          <label htmlFor="signup-email">email</label>
          <input
            type="text"
            id="signup-email"
            name="email"
            value={formData.email}
            onChange={handleEmailChange}
            placeholder="enter email"
            required
          />
          <br />
          <label htmlFor="signup-password">password</label>
          <input
            type="password"
            id="signup-password"
            name="password"
            value={formData.password}
            onChange={handlePasswordChange}
            placeholder="enter password"
            required
          />
          <br />
          <label htmlFor="signup-confirm-password">confirm password</label>
          <input
            type="password"
            id="signup-confirm-password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleConfirmPasswordChange}
            placeholder="confirm password"
            required
          />
          <br />

          <PasswordPolicyChecker
            password={formData.password}
            confirmPassword={formData.confirmPassword}
            onPasswordValidityChange={updatePasswordValidity}
          />

          <button type="submit" disabled={!isPasswordValid}>
            sign up
          </button>
        </form>

        <div className="base-modal-toggle">
          <h3>already have an account?</h3>
          <button onClick={toggleView}>login</button>
        </div>
      </div>
    </BaseModal>
  );
};

export default SignUpModal;
